import {
  token as publicToken,
  tokenInfo as publicTokenInfo,
} from './identity-oauth-v1-refresh-token-oauth.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const token: MaybeContext<
  BuildRESTFunction<typeof publicToken> & typeof publicToken
> = /*#__PURE__*/ createRESTModule(publicToken);
export const tokenInfo: MaybeContext<
  BuildRESTFunction<typeof publicTokenInfo> & typeof publicTokenInfo
> = /*#__PURE__*/ createRESTModule(publicTokenInfo);

export { SubjectType } from './identity-oauth-v1-refresh-token-oauth.universal.js';
export {
  RefreshToken,
  AuthorizeRequest,
  RawHttpResponse,
  HeadersEntry,
  RawHttpRequest,
  PathParametersEntry,
  QueryParametersEntry,
  DeviceCodeRequest,
  DeviceCodeResponse,
  DeviceVerifyRequest,
  DeviceVerifyResponse,
  DeviceVerifyV2Request,
  DeviceVerifyV2Response,
  InvalidateUserCodeRequest,
  InvalidateUserCodeResponse,
  RevokeRefreshTokenRequest,
  RevokeRefreshTokenResponse,
  TokenInfoResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  UserDeletedEvent,
  UserBlockedEvent,
  UserInfoRequest,
  UserInfoResponse,
  TokenOptions,
  TokenInfoOptions,
} from './identity-oauth-v1-refresh-token-oauth.universal.js';
export { SubjectTypeWithLiterals } from './identity-oauth-v1-refresh-token-oauth.universal.js';
